import React from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Button,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Box,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { Link } from "react-router-dom";
import CloseIcon from '@mui/icons-material/Close';
import Divider from '@mui/material/Divider';

export default function Header() {
  const [open, setOpen] = React.useState(false);
  const toggleDrawer = () => setOpen(!open);
  const navItems = [
    // { text: "Inicio", to: "/" },
    // { text: "Verificar Ticket", to: "/verificar" },
  ];

  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          background: (theme) => theme.palette.primary.main,
          color: "common.white",
          backdropFilter: "blur(8px)",
        }}
      >
        <Toolbar>
          {/* Spacer */}
          <Box sx={{ flexGrow: 1 }} />
          
          {/* Logo */}
          <Box
            component={Link}
            to="/"
            sx={{
              display: "flex",
              alignItems: "center",
              textDecoration: "none",
              color: "common.white",
              textShadow: "0 0 2px rgba(0,0,0,0.8)",
              position: "absolute",
              left: "50%",
              transform: "translateX(-50%)",
            }}
            aria-label="Ir a Inicio"
          >
            <Box
              component="img"
              src="/assets/images/logo.png"
              alt="GANA CON BENDICION EN MANOS Logo"
              height={50}
            />
          </Box>
          
          {/* CONALOT Logo */}
          <Box
            component="img"
            src="/assets/images/conalot-logo.png"
            alt="CONALOT"
            height={35}
            sx={{
              filter: "brightness(0) invert(1)",
              opacity: 0.9,
              transition: 'opacity 0.3s ease',
              '&:hover': {
                opacity: 1
              },
              ml: 2
            }}
          />

          <Box sx={{ display: { xs: "none", md: "block" } }}>
            {navItems.map((item) => (
              <Button
                key={item.text}
                component={Link}
                to={item.to}
                aria-label={item.text}
                sx={{
                  color: "common.white",
                  textShadow: "0 0 2px rgba(0,0,0,0.8)",
                  "&:hover, &:focus": {
                    backgroundColor: "rgba(255,255,255,0.2)",
                    outline: "none",
                  },
                }}
              >
                {item.text}
              </Button>
            ))}
          </Box>
          {/* <IconButton
            color="inherit"
            edge="start"
            sx={{ display: { md: "none" } }}
            onClick={toggleDrawer}
            aria-label="Abrir menú"
          >
            <MenuIcon />
          </IconButton> */}
        </Toolbar>
      </AppBar>
      <Toolbar />
      <Drawer
        anchor="left"
        open={open}
        onClose={toggleDrawer}
        sx={{
          '& .MuiDrawer-paper': {
            backgroundColor: '#fff',
            color: 'text.primary',
            width: '100vw',
            maxWidth: 300,
          },
        }}
      >
        {/* Close button */}
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 2 }}>
          <IconButton onClick={toggleDrawer} aria-label="Cerrar menú" sx={{ color: '#000' }}>
            <CloseIcon />
          </IconButton>
        </Box>
        <List>
          {navItems.map((item, index) => (
            <React.Fragment key={item.text}>
              <ListItem
                button
                component={Link}
                to={item.to}
                aria-label={item.text}
                onClick={toggleDrawer}
                sx={{
                  py: 2,
                  px: 3,
                  borderRadius: 1,
                  backgroundImage: 'linear-gradient(90deg, rgba(33,150,243,0.2) 0%, rgba(139,195,74,0.2) 33%, rgba(255,235,59,0.2) 66%, rgba(244,67,54,0.2) 100%)',
                  '&:hover': {
                    backgroundImage: 'linear-gradient(90deg, rgba(33,150,243,0.4) 0%, rgba(139,195,74,0.4) 33%, rgba(255,235,59,0.4) 66%, rgba(244,67,54,0.4) 100%)',
                  },
                }}
              >
                <ListItemText
                  primary={item.text}
                  primaryTypographyProps={{ variant: 'h6', color: 'text.primary' }}
                />
              </ListItem>
              {index < navItems.length - 1 && <Divider sx={{ borderColor: '#ccc' }} />}
            </React.Fragment>
          ))}
        </List>
      </Drawer>
    </>
  );
}
